import { render } from "./BlockOfferMain.vue?vue&type=template&id=16021338"
import script from "./BlockOfferMain.vue?vue&type=script&lang=js"
export * from "./BlockOfferMain.vue?vue&type=script&lang=js"

import "./BlockOfferMain.vue?vue&type=style&index=0&id=16021338&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__